import styled, {createGlobalStyle, css} from "styled-components";
import DatePicker from "react-datepicker";
import {light} from "./theme";

export const textColor = css`${props => props.theme.color.textColor}`
export const reverseTextColor = css`${props => props.theme.color.reverseTextColor}`
export const subColor = css`${props => props.theme.color.subColor}`
export const buttonHeightSize = 35
export const mainColor = css`${props => props.theme.color.mainColor}`
export const topicColor = css`${props => props.theme.color.topicColor}`
export const mainColorOpacity5 = css`${props => props.theme.color.mainColorOpacity5}`
export const mainColorOpacity20 = css`${props => props.theme.color.mainColorOpacity20}`
export const bgColor = css`${props => props.theme.color.bgColor}`
export const borderColor = css`${props => props.theme.color.borderColor}`
export const lightGray = css`${props => props.theme.color.lightGray}`
export const whiteColor = css`${props => props.theme.color.whiteColor}`

export const GlobalStyles = createGlobalStyle`
  html {
    font-size: 14px;
    word-break: break-all;
  }
  body {
    margin: 0;
    font-family: 'Noto Sans KR', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow-x: hidden;
  }
  html, body, button, input, textarea, pre {
    font-family: 'Noto Sans KR', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
    color: ${textColor};
  }

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
  //scrollbar 스타일 추가
    ::-webkit-scrollbar {
      width: 7px;
      height: 7px;
      background-color: #f5f5f5;
      &-track {
        box-shadow: inset 0 0 6px rgba(95, 78, 78, 0.1);
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
        border-radius: 10px;
        background-color: #f5f5f5;
      }
    }
    
    ::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background-color: rgba(85, 85, 85, 0.15);
    }
  pre {white-space: pre-wrap;}
  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
  }
  a {
    text-decoration: none;
    color: #777
  }
  ul,li,dd,dl,dt {
    text-decoration: none;
    list-style-type: none;
    margin: 0;
    padding: 0;
  }
  table {
    border-spacing: 0;
  }
  article {
    margin: 0 auto;
    width: 1580px;
  }

  article h1 {
    font-size: 2em;
  }

  article h2 {
    font-size: 1.7em;
  }

  article h3 {
    font-size: 1.5em;
  }

  article h4 {
    font-size: 1.2em;
  }

  article h5 {
    font-size: 1em;
  }

  article h6 {
    font-size: .07em;
  }
  

  #container {
    display: flex;
  }
  .InovuaReactDataGrid__column-header--show-border-left {
    border: none !important;
  }
  aside {
    position: -webkit-sticky; /* 사파리 브라우저 지원 */
    position: sticky;
    top: 0;
    align-self: flex-start;
  }
  button {
    border: 0;
    border-radius: 5px;
    cursor: pointer;
    &:disabled {
      cursor: no-drop;
    }
  }
  input, textarea {
    outline: none;
  }
  input::placeholder{
    color: #a2aab2;
  }

  input[type=range] {
    -webkit-appearance: none;
    width: 100%;
    height: 8px;
    background: ${lightGray};
    cursor: pointer;
    border-radius: 8px; 
  }

  input[type=range]:focus {
    outline: none;
  }

  input[type=range]::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 18px;
    height: 18px;
    background: #fff;
    border: 2px solid ${mainColor};
    border-radius: 50%;
    cursor: pointer;
  }

  input[type=range]::-moz-range-thumb {
    -webkit-appearance: none;
    width: 10px;
    height: 10px;
    background: #fff;
    border: 1px solid dodgerblue;
    border-radius: 50%;
    cursor: pointer;
  }
  
  input[type=range].read-only {
    background: ${lightGray} !important;
    cursor: no-drop;
    &::-webkit-slider-thumb {
      background: ${subColor};
      border:0;
      cursor: no-drop;
    }
    &::-moz-range-thumb {
      background: ${subColor};
      border:0;
      cursor: no-drop;
    }
  }
  
  input[type='text']:read-only {
    background-color: #eee;
    cursor: not-allowed;
  }
  input[type="radio"] {
    vertical-align: middle;
    appearance: none;
    width: 20px;
    height: 20px;
    background-image: url('/assets/images/common/selectcircle_off.png');
    background-image: -webkit-image-set(url('/assets/images/common/selectcircle_off.png') 1x,url('/assets/images/common/selectcircle_off@2x.png') 2x, url('/assets/images/common/selectcircle_off@3x.png') 3x)
  }
  input[type="radio"]:checked {
    background-image: url('/assets/images/common/selectcircle_on.png');
    background-image: -webkit-image-set(url('/assets/images/common/selectcircle_on.png') 1x,url('/assets/images/common/selectcircle_on@2x.png') 2x, url('/assets/images/common/selectcircle_on@3x.png') 3x)
  }
  input[type='radio'] + span {
    display: inline-block;
    margin: -1px 0 0 0;
  }
  label {
    display: flex;
    margin-right: 10px;
  }

  .react-datepicker__input-container input[type='text']{
    border: 0;
    height: calc(${buttonHeightSize}px - 2px);
  }
  .sign-up article {
    width: 1320px;
  }
  .checkbox-type-a {
    display: none;
  }
  .checkbox-type-a + label {
    vertical-align: top;
  }
  .checkbox-type-a + i{
    display: inline-block;
    margin: 0 8px;
    width: 14px;
    height: 20px;
    background-image: url('/assets/images/common/checkbox.png');
    background-image: -webkit-image-set(url('/assets/images/common/checkbox.png') 1x,url('/assets/images/common/checkbox@2x.png') 2x, url('/assets/images/common/checkbox@3x.png') 3x);
    background-repeat: no-repeat;
    background-position: center;
    vertical-align: top;
  }

  .checkbox-type-a:checked + i{
    background-image: url('/assets/images/common/checkbox_on.png');
    background-image: -webkit-image-set(url('/assets/images/common/checkbox_on.png') 1x,url('/assets/images/common/checkbox_on@2x.png') 2x, url('/assets/images/common/checkbox_on@3x.png') 3x);
  }

  .checkbox-type-b {
    display: none;
  }
  .checkbox-type-b + label {
    vertical-align: top;
  }
  .checkbox-type-b + i{
    display: inline-block;
    margin: 0 8px;
    width: 30px;
    height: 30px;
    background-image: url('/assets/images/common/checkbox_off_B.png');
    background-image: -webkit-image-set(url('/assets/images/common/checkbox_off_B.png') 1x,url('/assets/images/common/checkbox_off_B@2x.png') 2x, url('/assets/images/common/checkbox_off_B@3x.png') 3x);
    background-repeat: no-repeat;
    background-position: center;
    vertical-align: top;
  }

  .checkbox-type-b:checked + i{
    background-image: url('/assets/images/common/checkbox_on_B.png');
    background-image: -webkit-image-set(url('/assets/images/common/checkbox_on_B.png') 1x,url('/assets/images/common/checkbox_on_B@2x.png') 2x, url('/assets/images/common/checkbox_on_B@3x.png') 3x);
  }

  .checkbox-type-c {
    display: none;
  }

  .checkbox-type-c + label {
    vertical-align: top;
  }
  .checkbox-type-c + i{
    display: inline-block;
    margin: 0 8px;
    width: 18px;
    height: 18px;
    background-image: url('/assets/images/common/checkbox_off_C.png');
    background-image: -webkit-image-set(url('/assets/images/common/checkbox_off_C.png') 1x,url('/assets/images/common/checkbox_off_C@2x.png') 2x, url('/assets/images/common/checkbox_off_C@3x.png') 3x);
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }

  .checkbox-type-c:checked + i{
    background-image: url('/assets/images/common/checkbox_on_C.png');
    background-image: -webkit-image-set(url('/assets/images/common/checkbox_on_C.png') 1x,url('/assets/images/common/checkbox_on_C@2x.png') 2x, url('/assets/images/common/checkbox_on_C@3x.png') 3x);
  }
  .border-r {
    border-right: 1px solid ${lightGray}
  }
  .border-t {
    border-top: 1px solid ${lightGray}
  }

  .fadeOut {
    animation: 0.5s fadeOutAnimation;
    animation-fill-mode: forwards;
  }

  .fadeIn {
    animation: 0.5s fadeInAnimation;
    animation-fill-mode: forwards;
  }

  .icon-mode {
    padding-left: 18px !important;
    width: 60px !important;
    height: 60px !important;
    overflow: hidden;
    border-radius: 15px;
  }
  .list-mode {
    overflow: hidden;
  }
  .icon-mode > div{
    transition-duration: 0.5s;
  }
  .icon-mode + div {
    transition-duration: 0.5s;
    height: 0 !important;
  }
  .list-mode > div {
    transition-duration: 0.5s;
    margin-left: 0px;
  }

  .active > a {
    background-color: ${textColor};
  }

  .active span {
    color: #fff
  }

  .slide-down-1 {
    animation: 0.5s slideDownAnimation1;
    animation-fill-mode: forwards;
  }

  .slide-down-2 {
    animation: 0.5s slideDownAnimation2;
    animation-fill-mode: forwards;
  }
  .slide-down-3 {
    animation: 0.5s slideDownAnimation3;
    animation-fill-mode: forwards;
  }

  .slide-down-4 {
    animation: 0.5s slideDownAnimation4;
    animation-fill-mode: forwards;
  }

  .slide-down-5 {
    animation: 0.5s slideDownAnimation5;
    animation-fill-mode: forwards;
  }
  

  .slide-up {
    animation: 0.5s slideUpAnimation;
    animation-fill-mode: forwards;
    overflow: hidden;
  }

  .react-switch-checkbox {
    height: 0;
    width: 0;
    visibility: hidden;
    display: none;
  }

  .react-switch-label {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    width: 68px;
    height: 30px;
    background: ${lightGray};
    border-radius: 68px;
    position: relative;
    transition: background-color .2s;
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  }

  .react-switch-label .react-switch-button {
    content: '';
    position: absolute;
    top: 4px;
    left: 4px;
    width: 22px;
    height: 22px;
    border-radius: 22px;
    transition: 0.2s;
    background: #fff;
    box-shadow: 0 2px 3px 0 rgba(10, 10, 10, 0.4);
  }

  .react-switch-checkbox:checked + .react-switch-label .react-switch-button {
    left: calc(100% - 4px);
    transform: translateX(-100%);
  }

  .react-switch-checkbox:checked + .react-switch-label {
    background: ${mainColor};
  }

  .react-switch-label:active .react-switch-button {
    width: 22px;
  }

  .handled {
    cursor: move;
    cursor: grab;
  }
  .handled:active {
    cursor: grabbing;
  }
  
  .InovuaReactDataGrid--theme-default-light .InovuaReactDataGrid__column-header__content {
    font-weight: 400
  }
  .InovuaReactDataGrid__column-header__content .checkbox-type-a + i{
    display: none;
  }
  
  .ellipsis {
    text-overflow: ellipsis;
    white-space: nowrap !important;
    overflow: hidden;
  }
  
  .line-clamp_2 {
    overflow: hidden;
    display: -webkit-box !important;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical
  }
  
  .won:after {
    content: '원';
    margin-left: 5px;    
  }
  
  .pct:after {
    content: '%';
    margin-left: 5px;    
  }

  @keyframes slideUpAnimation {
    0% {
      height: 97px;
    }
    100% {
      height: 0;
    }
  }

  @keyframes slideDownAnimation1 {
    0% {
      height: 0;
    }
    100% {
      height: 68px;
    }
  }

  @keyframes slideDownAnimation2 {
    0% {
      height: 0;
    }
    100% {
      height: 100px;
    }
  }

  @keyframes slideDownAnimation3 {
    0% {
      height: 0;
    }
    100% {
      height: 150px;
    }
  }

  @keyframes slideDownAnimation4 {
    0% {
      height: 0;
    }
    100% {
      height: 180px;
    }
  }
  
  @keyframes slideDownAnimation5 {
    0% {
      height: 0;
    }
    100% {
      height: 210px;
    }
  }

  @keyframes slideDownAnimation6 {
    0% {
      height: 0;
    }
    100% {
      height: 210px;
    }
  }

  @keyframes fadeOutAnimation {
    0% {
      opacity: 1;
    }
    100% {
      height: 0;
      pointer-events: none;
      opacity: 0;
    }
  }

  @keyframes fadeInAnimation {
    0% {
      opacity: 0;
    }
    100% {
      display: block;
      opacity: 1;
    }
  }
  .react-confirm-alert {
    &-body {
      font-family: 'Noto Sans KR', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      padding: 25px;
      font-size: 15px;
      > h1 {
        font-size: 20px;
        margin-bottom: 10px;
      }
      &-element {
        overflow: auto !important;
      }
    }
    &-overlay {
      background-color: rgba(0, 0, 0, .7)
    }
    &-button-group {
      justify-content: center;
      margin-top: 30px
    }
    
  }
`

export const inputStyle = {
  indicatorSeparator: () => null,
  container: (styles) => ({
    ...styles,
    width: '100%',
  }),
  control: (styles,{isFocused,isDisabled}) => ({
    ...styles,
    backgroundColor: isDisabled ?'#F9FAFB' : 'white',
    border: '1px solid #e5e5e5',
    height: 45,
    borderRadius: 5,
    boxShadow: isFocused && `0 0 0 1px #1E3A8A`,
    ':hover': {
      ...styles[':hover'],
      borderColor: isFocused && `#1E3A8A`
    }
  }),
  option: (styles, { isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor:
          isDisabled ? undefined :
              isSelected ? `#1E3A8A` :
                  isFocused ? '#3B82F6'
                      :undefined,
      color:
          isDisabled ? '#222' :
              isSelected ? '#fff' : '#222',
      ':active': {
        ...styles[':active'],
        backgroundColor: !isDisabled ?
            isSelected ? `#1E3A8A`
                : undefined
            :undefined

      }
    }
  },
  input: (styles) => ({
    ...styles,
    height: 36,
    borderRadius: 5,
  }),
  placeholder: (styles) => ({
    ...styles
  }),
  singleValue: (styles, { data }) => ({
    ...styles
  }),
};

export const selectStyle = {
  indicatorSeparator: () => null,
  indicatorsContainer: (baseStyles,state) => (
    {
      ...baseStyles,
      height: '100%',
    }
  ),
  container:(baseStyles,{selectProps}) => (
    {
      ...baseStyles,
      width: selectProps.width !== undefined ? selectProps.width : '100%',
      height: '100%',
    }
  ),
  valueContainer: (baseStyles,state) => (
    {
      ...baseStyles,
      height: '100%',
    }
  ),
  option: (baseStyles,{isDisabled,isSelected,isFocused}) => (
    {
      ...baseStyles,
      backgroundColor:
        isDisabled ? undefined :
          isSelected ?  light.color.mainColor:
            isFocused ? light.color.mainColorOpacity20
              :undefined,
      color:
        isDisabled ? light.color.lightGray :
          isSelected ? '#fff' : light.color.textColor,
      ':active': {
        ...baseStyles[':active'],
        backgroundColor: !isDisabled ?
          isSelected ? light.color.mainColor
            : undefined
          :undefined

      }
    }),
  control: (baseStyles,{selectProps,isFocused}) => (
    {
      ...baseStyles,
      width: selectProps.width !== undefined ? selectProps.width : '100%',
      minHeight: buttonHeightSize,
      marginRight: '0 !important',
      borderColor: light.color.lightGray,
      boxShadow: isFocused && `0 0 0 1px ${light.color.mainColor}`,
      ':hover': {
        ...baseStyles[':hover'],
        borderColor: isFocused && light.color.mainColor
      }
    }
  ),
  input: (baseStyles,state) => (
    {
      ...baseStyles,
      width: '100%',
      height: buttonHeightSize - 10,
      borderRadius: 5,
    }
  )
}

export const smallStyle = {
  indicatorSeparator: () => null,
  indicatorsContainer: (baseStyles,state) => (
    {
      ...baseStyles,
      height: 24,
    }
  ),
  container:(baseStyles,state) => (
    {
      ...baseStyles,
      height: 24,
    }
  ),
  valueContainer: (baseStyles,state) => (
    {
      ...baseStyles,
      height: 24,
    }
  ),
  control: (baseStyles,state) => (
    {
      ...baseStyles,
      width: '100%',
      minHeight: 24,
      marginRight: '0 !important',
      border: `1px solid ${light.color.lightGray}`
    }
  ),
  input: (baseStyles,state) => (
    {
      ...baseStyles,
      width: '100%',
      height: 16,
      borderRadius: 5,
    }
  )
}

export const defaultStyle = {
  indicatorSeparator: () => null,
  indicatorsContainer: (baseStyles,state) => (
    {
      ...baseStyles,
      height: 36,
    }
  ),
  container:(baseStyles,state) => (
    {
      ...baseStyles,
      width: '100%',
      height: 36,
    }
  ),
  valueContainer: (baseStyles,state) => (
    {
      ...baseStyles,
      height: 36,
    }
  ),
  control: (baseStyles,state) => (
    {
      ...baseStyles,
      width: '100%',
      minHeight: 36,
      marginRight: '0 !important',
      border: `1px solid ${light.color.lightGray}`
    }
  ),
  input: (baseStyles,state) => (
    {
      ...baseStyles,
      width: '100%',
      height: 24,
      borderRadius: 5,
    }
  )
}
export const InputLabel = styled.div`
  width: ${(props) => props?.width !== undefined ? props?.width : '100%'};
  & > input {
    padding: 0 40px 0 20px;
  }
  &:after {
    display: inline-block;
    content: ${(props) => props?.label !== undefined && `'${props?.label}'`};
    margin-left: -35px;    
  }
`
export const TextMainColor = styled.span`
  color: ${mainColor};
  font-weight: bold;
`
export const BoardContainer = styled.div`
  padding: 30px 30px 10px;
  margin-right: 10px;
  margin-bottom: 10px;
  background-color: #f8f8f8;
  border-radius: 8px 0 8px 8px;
`

export const TitleContainer = styled.div`
  & h1 {
    font-size: 20px;
    font-weight: 700;
  }
`
export const Board = styled.div`
  margin-bottom: 10px;
  width: 100%;
  background-color: #fff;
  padding: 0 40px 40px 40px;
  border-radius: 20px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);
  border: solid 1px ${borderColor};
`


export const BoardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0 12px;
  width: 100%;
  border-bottom: 1px solid ${lightGray};
  font-weight: bold;
  &> div:first-child {
    font-size: 17px;
  }
`

export const BoardSearchDetail = styled.div`
  //flex-direction: ${(props) => props.column ? "column" : "row"};
  //display: flex;
  //padding: 10px 0;
  //font-size: 13px;
`

export const DashBoardCard = styled.div`
  margin-bottom: 10px;
  width: 100%;
  background-color: #fff;
  padding: 20px 35px;
  border-radius: 20px;
  border: solid 1px ${borderColor};
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);
`

export const DashBoardHeader = styled.div`
  margin-bottom: 15px;
  width: 100%;
  font-size: 17px;
  font-weight: bold;
`

export const DashBoardBody = styled.div`
  display: block;
`
export const BoardTap = styled.div`
  margin: 0 0 34px 0;
  width: 100%;
  background-color: #fff;
  padding: 30px 40px;
  border-radius: 0 20px 20px 20px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);
`

export const BoardTapTitle = styled.div`
  margin-top: 34px;
  padding: 12px 0;
  width: 300px;
  background-color: #fff;
  text-align: center;
  border-radius: 20px 20px 0 0;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  font-size: 17px;
  font-weight: bold;
`
export const BoardTableContainer = styled.div`
  & table {
    width: 100%;
    border-top: 1px solid ${lightGray};
    border-bottom: 1px solid ${lightGray};
    & tr {
      & th {
        padding: 14px 0;
        background-color: #fafafa;
        font-size: 15px;
        color: #b2b2b2;
        font-weight: normal;
        white-space: nowrap;
      }
      & td {
        padding: 14px 0;
        word-break: break-word;
        text-align: center;
        & a {
          border-bottom: 1px solid #777;
        }
      }
    }
  }
`

export const BoardTableCustomContainer = styled.div`
  & table {
    width: 100%;
    border: 1px solid ${lightGray};
    & tr {
      & th {
        padding: 14px 0;
        background-color: #fafafa;
        font-size: 15px;
        color: #b2b2b2;
        border-right: 1px solid ${lightGray};
        font-weight: normal;
        white-space: nowrap;
        &:last-child {border-right: 0}
      }
      & td {
        padding: 14px 0;
        word-break: break-word;
        border-top: 1px solid ${lightGray};
        border-right: 1px solid ${lightGray};
        text-align: center;
        &:last-child {border-right: 0}
        & a {
          border-bottom: 1px solid #777;
        }
      }
    }
  }
`

export const RowSpan = styled.div`
  display: flex;
  flex-direction: ${(props) => props.column ? "column" : "row"};
  gap: ${(props) => props.box ? "10px" : null};
  justify-content: space-between;
  margin-top: ${(props) => props.box ? "15px" : "15px"};
  padding-bottom: ${(props) => props.validation ? "10px" : null};
  padding: ${(props) => props.box ? "15px" : null};
  background-color: ${(props)=>props.box ? "#f9fafb":null};
  border: ${(props) => props.box ? `1px solid` : null};
  border-color: ${(props) => props.box ? lightGray : null};
  border-radius: 5px;
`

export const FoldSpan = styled.div`
  display: flex;
  flex-direction: ${(props) => props.column ? "column" : "row"};
  gap: ${(props) => props.box ? "10px" : null};
  justify-content: space-between;
  margin-top: 15px;
  padding: ${(props) => props.box ? "15px" : null};
  background-color: ${(props)=>props.box ? "#f9fafb":null};
  border: ${(props) => props.box ? '1px solid' : null};
  border-color: ${(props) => props.box ? lightGray : null};
  border-radius: 5px;
  height: 0;
  overflow: hidden;
`
export const ColSpan0 = styled.div`
  padding-left: ${(props) => props.padding ? props.padding : '10'}px;
  display: flex;
  align-items: center;
  width: auto;
  min-height: 35px;
  gap: 10px;
  & > div:first-child {
    white-space: nowrap;
    flex-shrink: 0;
  }
`


export const ColSpan1 = styled.div`
  position: relative;
  padding-left: ${(props) => props.padding ? props.padding : '10'}px;
  display: flex;
  align-items: center;
  width: 25%;
  gap: 10px;
  & > div.relative {
    position: relative;
  }
  & > div:first-child {
    white-space: nowrap;
    flex-shrink: 0;
  }
  & > div:last-child {
    display: flex;
    width: 100%;
    min-height: 35px;
    align-items: center;
  }
  //& > div:last-child > * {
  //  margin-right: 10px;
  //}
`

export const ColSpan2 = styled.div`
  position: relative;
  padding-left: ${(props) => props.padding ? props.padding : '10'}px;
  display: flex;
  flex-direction: ${(props)=>props.column ? 'column' : 'row'};
  align-items: ${(props)=>props.column ? 'flex-start' : 'center'};
  width: 50%;
  gap: 10px;
  & > div.relative {
    position: relative;
  }
  & > div:first-child {
    white-space: nowrap;
    flex-shrink: 0;
  }
  & > div:last-child {
    display: flex;
    width: 100%;
    min-height: 35px;
    align-items: center;
  }
`

export const ColSpan3 = styled.div`
  padding-left: ${(props) => props.padding ? props.padding : '10'}px;
  display: flex;
  align-items: center;
  width: 75%;
  gap: 10px;
  & > div.relative {
    position: relative;
  }
  & > div:first-child {
    white-space: nowrap;
    flex-shrink: 0;
  }
  & > div:last-child {
    display: flex;
    width: 100%;
    min-height: 35px;
    padding-right: 5px;
    align-items: center;
  }
  & > div:last-child > * {
    margin-right: 10px;
  }
`

export const ColSpan4 = styled.div`
  position: relative;
  padding-left: ${(props) => props.padding ? props.padding : '10'}px;
  display: flex;
  align-items: center;
  width: 100%;
  gap: 10px;
  & > div.relative {
    position: relative;
  }
  & > div:first-child {
    white-space: nowrap;
    flex-shrink: 0;
  }
  & > div:last-child {
    display: flex;
    width: 100%;
    min-height: 35px;
    padding-right: 5px;
    align-items: center;
  }
  & > div:last-child > * {
    margin-right: 10px;
  }
`

export const ColSpan100 = styled.div`
  position: relative;
  padding-left: ${(props) => props.padding ? props.padding : '10'}px;
  display: flex;
  align-items: center;
  max-width: 100px;
  width: 100%;
`
export const ColTitle = styled.div`
  padding: 0 10px 0 0;
  min-width: 65px;
  text-align: left;
  white-space: nowrap;
`

export const AgentType = styled.div`
  padding: 0 10px;
  display: flex;
  align-items: center;
  background-color: #f9fafb;
  height: 35px;
  border: 1px solid ${lightGray};
  border-radius: 5px;
  & label {
    white-space: nowrap;
  }
`
export const CampaignType = styled.div`
  padding: 40px;
  display: flex;
  justify-content: center;
  width: 100%;
  gap: 30px;
  background-color: #f9fafb;
  border: 1px solid ${lightGray};
  border-radius: 5px;
`
export const DateContainer = styled.div`
  display: flex;
  width: 100%;
  border: 1px solid ${lightGray};
  border-radius: 5px;
  overflow: hidden;
  background-color: ${(props)=> props.disabled ? "#f9fafb" : "#fff"};
  & input[type="text"] {
    height: 35px;
    font-size: 13px;
    background-color: #ffffff;
  }
`

export const CalendarBox = styled.div`
  display: flex;
  width: 55px;
  min-height: 33px;
  border-right: 1px solid ${lightGray};
  justify-content: center;
  align-items: center;
  background-color: #f9f9f9;
`

export const CalendarIcon = styled.div`
  width: 18px;
  height: 20px;
  background-repeat: no-repeat;
  background-image: url("/assets/images/common/icon_calendar.png");
  background-image: -webkit-image-set(url('/assets/images/common/icon_calendar.png') 1x,url('/assets/images/common/icon_calendar@2x.png') 2x, url('/assets/images/common/icon_calendar@3x.png') 3x);
`

export const CustomDatePicker = styled(DatePicker)`
  border: none !important;
  color: #a2aab2;
  font-size: 14px;
  width: 100%;
  padding: 0 20px;
`

export const RangePicker = styled.div`
  padding: 0px 20px;
  display: flex;
  justify-content: space-around;
  width: 100%;
  -webkit-box-align: center;
  align-items: center;
  background-color: #f9fafb;
  border: 1px solid ${lightGray};
  border-radius: 5px;
  
  height: ${buttonHeightSize}px;
  color: #777;
  & div {
    cursor: pointer;
  }
`

export const SearchInput = styled.div`
  position: relative;
  width: 100%;
  & input[type='text'] {
    padding: 0 20px;
    width: 100%;
    height: ${buttonHeightSize}px;
    border: 1px solid ${lightGray};
    border-radius: 5px;
  }
`

export const SearchButton = styled.button`
  width: 140px;
  height: ${buttonHeightSize}px;
  background-color: ${mainColor} !important;
  border-radius: 5px;
  color: ${whiteColor}
`
export const GraySearchButton = styled.button`
  min-width: 140px;
  min-height: 35px;
  background-color: ${mainColor} !important;
  border-radius: 5px;
  color: ${whiteColor}
`

export const ResetButton = styled.button`
  padding: 0 10px;
  height: ${buttonHeightSize}px;
  border: 1px solid ${lightGray};
  background-color: #fff;
  border-radius: 5px;
`
export const BoardSearchResult = styled.div`
  margin: 20px 0;
`

export const BoardSearchResultTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding: 0 0 20px 0;
  & span {
    color: ${mainColor};
  }
`

export const SaveExcelButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 140px;
  height: ${buttonHeightSize}px;
  border: 1px solid;
  color: ${mainColor};
  background-color:  ${whiteColor};
  border-color:  ${mainColor};
  &.listUp {
    &:after {
      background-image: url("/assets/images/common/icon_listup_on.png");
    }
    &:hover:after{
      background-image: url("/assets/images/common/icon_listup_off_white.png");
    }
  }
  &:after {
    margin-left: 5px;
    display: inline-block;
    content:"";
    width: 20px;
    height: 20px;
    background-image: url("/assets/images/common/icon_excel_on.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 20px;
  }
  &:hover {
    color: ${whiteColor};
    background-color:  ${mainColor};
    border-color:  ${whiteColor};
    &:after{
      background-image: url("/assets/images/common/icon_excel_off_white.png");
    }
  }
`
export const ChartContainer = styled.div`
  margin: 20px 0 0 0;
  padding: 20px;
  border: 1px solid ${lightGray};
  border-radius: 5px;
`
export const ChartLabels = styled.div`
  display: flex;
  align-items: center;
  gap: 25px;
`

export const ChartLabel = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 100px;
  cursor: pointer;
  border: 1px solid ${subColor};
  border-radius: 5px;
  color: ${(props) => props.active ? `${textColor}`:`${subColor}` };
  > p {
    display: flex;
    align-items: center;
    height: 36px;
    padding-left: 10px;
  }
  > div {
    width: 125px;
    > div {
      cursor: pointer;
      border-width: 0;
    }
  }
  > span {
    display: flex;
    width: 100%;
    height: 30px;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    border-top: 1px solid ${subColor};
  }
`

export const ChartTooltip = styled.div`
  background: #fff;
  padding: 3px 10px;
  border: 1px solid ${subColor};
  border-radius: 3px;
  font-size: 13px;
  & .date {
    font-size: 15px;
    margin: 5px 0;
  }
`

export const Span1 = styled.span`
  display: inline-block;
  width: 60px;
`
export const Span2 = styled.span`
  display: inline-block;
  width: 80px;
`
export const Span3 = styled.span`
  display: inline-block;
  width: 100px;
`
export const Span4 = styled.span`
  display: inline-block;
  width: 140px;
  
`

export const SubmitContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 30px;
  width: 100%;
  & button {
    margin: 8px;
    width: 140px;
    height: 50px;
    font-size: 16px;
    cursor: pointer;
  }
`
export const CancelButton = styled.button`
  border: 1px solid #535353;
  background-color: #fff;
`

export const SubmitButton = styled.button`
  background-color: #535353;
  color: #fff;
`

export const DefaultButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 140px;
  height: ${buttonHeightSize}px;
  border: 1px solid ${lightGray};
  background-color: ${mainColor};
  color: #fff;
  cursor: ${(props)=>props.disabled? "not-allowed":'pointer'};
`

export const DeleteButton = styled.button`
  width: 24px;
  height: 24px;
  background-color: transparent;
  background-image: url("/assets/images/common/btn_delete_off.png");
  background-image: -webkit-image-set(url("/assets/images/common/btn_delete_off.png") 1x, url("/assets/images/common/btn_delete_off@2x.png") 2x, url("/assets/images/common/btn_delete_off@3x.png") 3x);
  background-repeat: no-repeat;
  background-position: center;
  position: absolute;
  right: 15px;
  &:hover {
    background-image: url("/assets/images/common/btn_delete_on.png");
    background-image: -webkit-image-set(url("/assets/images/common/btn_delete_on.png") 1x, url("/assets/images/common/btn_delete_on@2x.png") 2x, url("/assets/images/common/btn_delete_on@3x.png") 3x);
  }
`

export const TrashButton = styled.button`
  width: 24px;
  height: 24px;
  background-image: url("/assets/images/common/btn_delete_off.png");
  background-image: -webkit-image-set(url("/assets/images/common/btn_delete_off.png") 1x, url("/assets/images/common/btn_delete_off@2x.png") 2x, url("/assets/images/common/btn_delete_off@3x.png") 3x);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  background-color: transparent;
  &:hover {
    background-image: url("/assets/images/common/btn_delete_on_white.png");
  }
`
export const DownLoadButton = styled.button`
  width: ${buttonHeightSize}px;
  height: ${buttonHeightSize}px;
  background-color: transparent;
  background-image: url("/assets/images/common/icon_excel_off.png");
  background-repeat: no-repeat;
  background-position: center;
  position: absolute;
  border-left: 1px solid ${lightGray};
  border-radius:0;
  right: 10px;
  &:hover {
    background-image: url("/assets/images/common/icon_excel_on.png");
    background-image: -webkit-image-set(url("/assets/images/common/icon_excel_on.png") 1x, url("/assets/images/common/icon_excel_on@2x.png") 2x, url("/assets/images/common/icon_excel_on@3x.png") 3x);
  }
`

export const ValidationScript = styled.div`
  position: absolute;
  bottom: -18px;
  left: 5px;
  color: #f55a5a;
  font-size: 12px !important;
`
export const Input = styled('input')`
  padding:0 20px;
  width: 100%;
  text-align : ${(props)=>props?.textAlign !== 'right' ? 'left' : 'right'};
  border: 1px solid ${lightGray};
  height: ${buttonHeightSize}px;
  border-radius: 5px;
  background-color: ${(props)=>props.readOnly? '#eee': '#fff'};
  .btn-delete {
    width: 35px;
    height: 35px;
    background-image: url("/assets/images/common/btn_delete_off.png");
    background-image: -webkit-image-set(url("/assets/images/common/btn_delete_off.png") 1x, url("/assets/images/common/btn_delete_off@2x.png") 2x, url("/assets/images/common/btn_delete_off@3x.png") 3x);
    background-repeat: no-repeat;
    background-position: center;
    &:hover {
      background-image: url("/assets/images/common/btn_delete_on.png");
      background-image: -webkit-image-set(url("/assets/images/common/btn_delete_on.png") 1x, url("/assets/images/common/btn_delete_on@2x.png") 2x, url("/assets/images/common/btn_delete_on@3x.png") 3x);
    }
  }
`

export const RelativeDiv = styled.div`
  display: flex;
  flex-direction: ${(props) => props.column ? "column" : "row"};
  align-items: ${(props) => props.column ? "flex-start !important" : "center"};
  position: relative;
  width: 100%;
  padding: ${(props) => props.box ? "15px": null};
  background-color: ${(props) => props.box ? "#f9fafb": null};
  border-radius: ${(props) => props.box ? "5px": null};
  border: ${(props) => props.box ? '1px solid': null};
  border-color: ${(props) => props.box ? lightGray: null};
  & > * {
    margin-right: 10px;
    //background-color: #fff;
  }
  & label {
      margin-right: 20px;
    &:last-child {
      margin-right: 0;
    }
  }
  & label > input {
    margin-right: 10px;
  }
`
export const AbsoluteDiv = styled.div`
  position: absolute;
  top: 10px;
  left: 50px;
  padding: 7px 12px;
  z-index: 1000;
  border: 1px solid ${lightGray};
  background-color: #f3f3f3;
  & > * {
    margin-right: 10px;
  }
`

export const TableButton = styled.button`
  padding: 7px 12px;
  border: 1px solid ${lightGray};
  background-color: #f3f3f3;
  border-radius: 5px;
`

export const Check = styled.div`
  display: inline-block;
  width: 20px;
  height: 20px;
  background-image: url("/assets/images/table/icon_check@2x.png");
  background-image: -webkit-image-set(url("/assets/images/table/icon_check.png") 1x, url("/assets/images/table/icon_check@2x.png") 2x, url("/assets/images/table/icon_check@3x.png") 3x);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 20px;
`

export const Edit = styled.div`
  display: inline-block;
  width: 35px;
  height: 35px;
  cursor: pointer;
  background-image: url("/assets/images/table/icon_correction_off@2x.png");
  background-image: -webkit-image-set(url("/assets/images/table/icon_correction_off.png") 1x, url("/assets/images/table/icon_correction_off@2x.png") 2x, url("/assets/images/table/icon_correction_off@3x.png") 3x);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 20px;
  &:hover {
    background-image: url("/assets/images/table/icon_correction_on@2x.png");
    background-image: -webkit-image-set(url("/assets/images/table/icon_correction_on.png") 1x, url("/assets/images/table/icon_correction_on@2x.png") 2x, url("/assets/images/table/icon_correction_on@3x.png") 3x);
  }
`
export const Script = styled.div`
  cursor: pointer;
  display: inline-block;
  width: 35px;
  height: 35px;
  border-radius: 5px;
  background-image: url("/assets/images/table/icon_pop_off@2x.png");
  background-image: -webkit-image-set(url("/assets/images/table/icon_pop_off.png") 1x, url("/assets/images/table/icon_pop_off@2x.png") 2x, url("/assets/images/table/icon_pop_off@3x.png") 3x);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 20px;
  &:hover {
    background-image: url("/assets/images/table/icon_pop_on@2x.png");
    background-image: -webkit-image-set(url("/assets/images/table/icon_pop_on.png") 1x, url("/assets/images/table/icon_pop_on@2x.png") 2x, url("/assets/images/table/icon_pop_on@3x.png") 3x);
  }
`

export const Site = styled.div`
  display: inline-block;
  width: 35px;
  height: 35px;
  border-radius: 5px;
  background-image: url("/assets/images/table/icon_url_off.png");
  background-image: -webkit-image-set(url("/assets/images/table/icon_url_off.png") 1x, url("/assets/images/table/icon_url_off@2x.png") 2x, url("/assets/images/table/icon_url_off@3x.png") 3x);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 20px;
  &:hover {
    background-color: #f9fafb;
  }
`

export const CopyCode = styled.div`
  display: inline-block;
  width: 35px;
  height: 35px;
  border-radius: 5px;
  background-image: url("/assets/images/table/icon_copy_off.png");
  background-image: -webkit-image-set(url("/assets/images/table/icon_copy_off.png") 1x, url("/assets/images/table/icon_copy_off@2x.png") 2x, url("/assets/images/table/icon_copy_off@3x.png") 3x);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 20px;
  cursor: pointer;
  &:hover {
    background-image: url("/assets/images/table/icon_copy_on.png");
  background-image: -webkit-image-set(url("/assets/images/table/icon_copy_on.png") 1x, url("/assets/images/table/icon_copy_on@2x.png") 2x, url("/assets/images/table/icon_copy_on@3x.png") 3x);
  }
`

export const ReportsDetail = styled.div`
  margin-left: 10px;
  display: inline-block;
  width: 35px;
  height: 35px;
  border-radius: 5px;
  background-image: url("/assets/images/table/icon_pop_off@2x.png");
  background-image: -webkit-image-set(url("/assets/images/table/icon_pop_off.png") 1x, url("/assets/images/table/icon_pop_off@2x.png") 2x, url("/assets/images/table/icon_pop_off@3x.png") 3x);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 20px;
  &:hover {
    background-color: #f9fafb;
  }
`

export const TextArea = styled.textarea`
  width: 100%;
  padding-top: 10px;
  padding-left: 10px;
  border: 1px solid rgb(229, 229, 229);
  border-radius: 5px;
  resize: none;
  ::placeholder {
    color: #bbb;
  }
  :read-only {
    cursor: not-allowed;
    background-color: #eee;
  }
`
export const ColFraction = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 33.333333%;
  gap: 10px;
  & > div:last-child {
    position: relative;
    width: 100%;
  }
`